<template>
<div class="container-fluid">
<div class="row d-print-none justify-content-center">
    <div class="col-12 col-md-12 col-lg-12">
      
      <div class="card shadow-sm mt-4 border-top-primary">
        <div class="card-header bg-white py-3">
          <h5 class="mb-0 text-primary fw-bold">
            <i class="fas fa-search ms-2"></i> استعلام عن الطلاب
          </h5>
        </div>
        
        <div class="card-body">
          <div class="row g-3 align-items-end">
            
            <!-- 1. نوع البحث (Select) -->
            <div class="col-md-4">
              <label class="form-label fw-bold small">بحث بواسطة</label>
              <div class="input-group">
                <span class="input-group-text bg-light"><i class="fas fa-filter text-secondary"></i></span>
                <select v-model="form.check" class="form-select">
                  <option value="" disabled selected>-- اختر --</option>
                  <option value="nationality_id">الرقم القومي</option> <!-- تم تعديل الاسم ليكون أوضح -->
                  <option value="mange_id">كود الإدارة</option>
                  <option value="school_id">كود المدرسة</option> <!-- افترضت وجوده -->
                  <option value="sitting_number">رقم الجلوس</option>
                </select>
              </div>
            </div>

            <!-- 2. قيمة البحث (Input) -->
            <div class="col-md-4">
              <label class="form-label fw-bold small">قيمة البحث</label>
              <input 
                v-model="form.id" 
                type="text" 
                class="form-control" 
                placeholder="اكتب هنا..." 
                @keyup.enter="GethataStudentBySchools(472107787)" 
              />
            </div>

            <!-- 3. زر التنفيذ -->
            <div class="col-md-2">
              <!-- تم نقل الحدث للزر بدلاً من الضغط على الانبوت نفسه -->
              <button @click="GethataStudentBySchools(form.id)" class="btn btn-primary w-100 fw-bold">
                <i class="fas fa-search"></i> بحث
              </button>
            </div>
            <div class="col-md-2">
             <button class="btn btn-dark w-100" @click="printPage">
               <i class="fas fa-print ms-2"></i> طباعة
             </button>
          </div>

          </div>
        </div>
      </div>

    </div>
  </div>

    <table width="100%" cellpadding="0" cellspacing="0" border="0" dir="ltr" id="printMe">
        <!-- <tr v-for=" student in students"> -->
        <tr >

            <td align="center">

                <table class="jrPage" data-jr-height="842" cellpadding="0" cellspacing="0" border="0" style="empty-cells: show; width: 100%; border-collapse: collapse; background-color: white; margin-bottom: 40px;">
                   
                    <tr valign="top" style="height:2px">
                        <td colspan="21">
                        </td>
                    </tr>
                   
                    <tr class="certificate-row">
    <td colspan="21" class="p-0">
      <div class="certificate-container" dir="rtl">
        
        <!-- 1. ترويسة الشهادة (Header) -->
        <div class="cert-header d-flex justify-content-between align-items-start">
          
          <!-- اليمين: البيانات الإدارية -->
          <div class="header-right text-right">
            <h5 class="org-title">محافظة شمال سيناء</h5>
            <h5 class="org-title">مديرية التربية والتعليم</h5>
            <h5 class="org-title">لجنة النظام والمراقبة</h5>
          </div>

          <!-- الوسط: عنوان الشهادة وحالة النجاح -->
          <div class="header-center text-center">
            <div class="success-badge">
              ناجح دور أول 2024
            </div>
            <div class="cert-title">
              <p>بيانات تحررها لجنة النظام والمراقبة للإمتحان</p>
              <p class="highlight">إخطار بدرجات الطالب فى الامتحان</p>
            </div>
          </div>

          <!-- اليسار: الصورة الشخصية -->
          <div class="header-left text-center">
              <div class="number-box seat-box">
              <span class="label">رقم الجلوس:</span>
              <span class="value">{{ student.Seating_No_1 }}</span>
           </div>
            <div class="photo-frame">
              <img 
                :src="`../personal/${student.Code_School}/${student.Student_Code}.jpg`" 
                alt="صورة الطالب"
                class="student-img"
              />
                <!-- @error="$event.target.src = '/img/avatar.png'"  -->
            </div>
          </div>
        </div>

        <!-- 2. صناديق الأرقام (جلوس + مسلسل) -->
        <div class="cert-numbers d-flex justify-content-between align-items-center my-4">
           <!-- رقم الجلوس (يمين) -->
         

           <!-- مسلسل (يسار) -->
           <!-- <div class="number-box serial-box">
              <span class="label">مسلسل:</span>
              <span class="value"></span>
           </div> -->
        </div>

        <!-- 3. بيانات الطالب (Body) -->
        <div class="cert-body">
          <div class="info-row">
            <span class="info-label">اسم الطالب:</span>
            <span class="info-value font-weight-bold">{{ student.Arabic_Name }}</span>
          </div>

          <div class="info-row">
            <span class="info-label">اسم المدرسة:</span>
            <span class="info-value">{{ student.School_Name }}</span>
          </div>

          <div class="info-row">
            <span class="info-label">الإدارة التعليمية:</span>
            <span class="info-value">إدارة {{ student.Dept_Name }} التعليمية</span>
          </div>
        </div>

        <hr class="divider" />

        <!-- 4. تذييل المعلومات (Footer Info) -->
        <div class="cert-footer d-flex justify-content-around align-items-center">
          <div class="footer-item">
            <span class="f-label">حالة القيد:</span>
            <span class="f-value">{{ student.Status_Desc }}</span>
          </div>
          <div class="footer-item">
            <span class="f-label">الجنسية:</span>
            <span class="f-value">{{ student.Nationality_Name }}</span>
          </div>
          <div class="footer-item">
            <span class="f-label">الرقم القومي:</span>
            <span class="f-value font-number">{{ student.Nationality == 1 ? student.National_No : 'غير مصري' }}</span>
          </div>
        </div>

      </div>
    </td>
  </tr>
                    <tr valign="top" style="height:45px">
                        <td>
                        </td>
                        <td colspan="10" dir="rtl" style="border-top: 2.5px solid #000000; border-left: 2.5px solid #000000; border-bottom: 1px solid #000000; border-right: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class=" s_h">ثانياً: مواد لا تضاف الى المجموع الكلى</span></td>
                        <td rowspan="3" style="border: 1px  solid #000000; border-top: 2.5px solid #000000; text-indent: -60px; ">
                            <div style="position: relative;  width:42px;height:124px;">
                                <span class="rotated" data-rotation="left" style="position: absolute; display: table; width:124px;height:42px;text-align: center;-webkit-transform: translate(-27px,41px) rotate(-90deg); -moz-transform: translate(-27px,41px) rotate(-90deg); -ms-transform: translate(-27px,41px) rotate(-90deg); -o-transform: translate(-27px,41px) rotate(-90deg); filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3); "><span style="display: table-cell; vertical-align:middle;"><span class=" s">المجموع الكلى</span></span></span></div>
                        </td>
                        <td colspan="7" dir="rtl" style="border-top: 2.5px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class=" s_h">اولا: مواد تضاف الى المجموع الكلى</span></td>
                        <td rowspan="3" dir="rtl" style="border-top: 2.5px solid #000000; border-left: 1px solid #000000; border-bottom: 1px solid #000000; border-right: 2.5px solid #000000; text-indent: 0px; text-align: center;">
                            <!-- <span style="font-family: 'Jordan', Arial, Helvetica, sans-serif; color: #000000; font-size: 10px; line-height: 1.1640625;">المادة
                                
                                </span> -->
                            <div>
                                <img :src="'../front-end/north.jpeg'" class="img" />

                            </div>
                        </td>
                        <td>
                        </td>
                    </tr>
                    <tr valign="top" style="height:21px">
                        <td>
                        </td>
                        <td rowspan="2" style="border-top: 1px solid #000000; border-left: 2.5px solid #000000; border-bottom: 1px solid #000000; border-right: 1px solid #000000; text-indent: -45px; ">
                            <div style="position: relative;  width:29px;height:89px;">
                                <span class="rotated" data-rotation="left" style="position: absolute; display: table; width:89px;height:29px;text-align: center;-webkit-transform: translate(-30px,30px) rotate(-90deg); -moz-transform: translate(-30px,30px) rotate(-90deg); -ms-transform: translate(-30px,30px) rotate(-90deg); -o-transform: translate(-30px,30px) rotate(-90deg); filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3); "><span style="display: table-cell; vertical-align:middle;"><span class="span">مستوى فرنسى</span></span></span></div>
                        </td>
                        <td rowspan="2" style="border: 1px solid #000000; text-indent: -46px; ">
                            <div style="position: relative;  width:28px;height:89px;">
                                <span class="rotated" data-rotation="left" style="position: absolute; display: table; width:89px;height:28px;text-align: center;-webkit-transform: translate(-30px,30px) rotate(-90deg); -moz-transform: translate(-30px,30px) rotate(-90deg); -ms-transform: translate(-30px,30px) rotate(-90deg); -o-transform: translate(-30px,30px) rotate(-90deg); filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3); "><span style="display: table-cell; vertical-align:middle;"><span class="span">مستوى انجليزى</span></span></span></div>
                        </td>
                        <td colspan="2" rowspan="2" style="border: 1px solid #000000; text-indent: -45px; ">
                            <div style="position: relative;  width:28px;height:89px;">
                                <span class="rotated" data-rotation="left" style="position: absolute; display: table; width:89px;height:28px;text-align: center;-webkit-transform: translate(-30px,30px) rotate(-90deg); -moz-transform: translate(-30px,30px) rotate(-90deg); -ms-transform: translate(-30px,30px) rotate(-90deg); -o-transform: translate(-30px,30px) rotate(-90deg); filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3); "><span style="display: table-cell; vertical-align:middle;"><span class="span">التربية الرياضية</span></span></span></div>
                        </td>
                        <td rowspan="2" style="border: 1px solid #000000; text-indent: -45px; ">
                            <div style="position: relative;  width:31px;height:89px;">
                                <span class="rotated" data-rotation="left" style="position: absolute; display: table; width:89px;height:31px;text-align: center;-webkit-transform: translate(-19px,29px) rotate(-90deg); -moz-transform: translate(-19px,29px) rotate(-90deg); -ms-transform: translate(-19px,29px) rotate(-90deg); -o-transform: translate(-19px,29px) rotate(-90deg); filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3); "><span style="display: table-cell; vertical-align:middle;"><span class="span">الحاسب الآلى</span></span></span></div>
                        </td>
                        <td rowspan="2" style="border: 1px solid #000000; text-indent: -45px; ">
                            <div style="position: relative;  width:31px;height:89px;">
                                <span class="rotated" data-rotation="left" style="position: absolute; display: table; width:89px;height:31px;text-align: center;-webkit-transform: translate(-19px,29px) rotate(-90deg); -moz-transform: translate(-19px,29px) rotate(-90deg); -ms-transform: translate(-19px,29px) rotate(-90deg); -o-transform: translate(-19px,29px) rotate(-90deg); filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3); "><span style="display: table-cell; vertical-align:middle;"><span class="span">التربية الفنية</span></span></span></div>
                        </td>
                        <td colspan="2" rowspan="2" style="border: 1px solid #000000; text-indent: -45px; ">
                            <div style="position: relative;  width:31px;height:89px;">
                                <span class="rotated" data-rotation="left" style="position: absolute; display: table; width:89px;height:31px;text-align: center;-webkit-transform: translate(-19px,29px) rotate(-90deg); -moz-transform: translate(-19px,29px) rotate(-90deg); -ms-transform: translate(-19px,29px) rotate(-90deg); -o-transform: translate(-19px,29px) rotate(-90deg); filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3); "><span style="display: table-cell; vertical-align:middle;"><span class="span">التربية الدينية</span></span></span></div>
                        </td>
                        <td colspan="2" dir="rtl" style="border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class=" s_bb">
                                <p class="mt-1">الانشطة التربوية </p>
                                <p class="m-0">اللاصيفية</p>
                            </span></td>
                        <td rowspan="2" style="border: 1px solid #000000; text-indent: -66px; ">
                            <div style="position: relative;  width:31px;height:89px;">
                                <span class="rotated" data-rotation="left" style="position: absolute; display: table; width:89px;height:31px;text-align: center;-webkit-transform: translate(-19px,29px) rotate(-90deg); -moz-transform: translate(-19px,29px) rotate(-90deg); -ms-transform: translate(-19px,29px) rotate(-90deg); -o-transform: translate(-19px,29px) rotate(-90deg); filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3); "><span style="display: table-cell; vertical-align:middle;"><span class="span">العلوم</span></span></span></div>
                        </td>
                        <td colspan="3" dir="rtl" style="border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class=" s">الرياضيات</span></td>
                        <td rowspan="2" style="border: 1px solid #000000; text-indent: -45px; ">
                            <div style="position: relative;  width:31px;height:89px;">
                                <span class="rotated" data-rotation="left" style="position: absolute; display: table; width:89px;height:31px;text-align: center;-webkit-transform: translate(-19px,29px) rotate(-90deg); -moz-transform: translate(-19px,29px) rotate(-90deg); -ms-transform: translate(-19px,29px) rotate(-90deg); -o-transform: translate(-19px,29px) rotate(-90deg); filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3); "><span style="display: table-cell; vertical-align:middle;"><span class="span">الدراسات الاجتماعية</span></span></span></div>
                        </td>
                        <td rowspan="2" style="border: 1px solid #000000; text-indent: -47px; ">
                            <div style="position: relative;  width:31px;height:89px;">
                                <span class="rotated" data-rotation="left" style="position: absolute; display: table; width:89px;height:31px;text-align: center;-webkit-transform: translate(-19px,29px) rotate(-90deg); -moz-transform: translate(-19px,29px) rotate(-90deg); -ms-transform: translate(-19px,29px) rotate(-90deg); -o-transform: translate(-19px,29px) rotate(-90deg); filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3); "><span style="display: table-cell; vertical-align:middle;"><span class="span">اللغــــة الانجليزيــــــة</span></span></span></div>
                        </td>
                        <td rowspan="2" style="border: 1px solid #000000; text-indent: -47px; ">
                            <div style="position: relative;  width:31px;height:89px;">
                                <span class="rotated" data-rotation="left" style="position: absolute; display: table; width:89px;height:31px;text-align: center;-webkit-transform: translate(-19px,29px) rotate(-90deg); -moz-transform: translate(-19px,29px) rotate(-90deg); -ms-transform: translate(-19px,29px) rotate(-90deg); -o-transform: translate(-19px,29px) rotate(-90deg); filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3); "><span style="display: table-cell; vertical-align:middle;"><span class="span">اللغـــــــــــة العربيــــة</span></span></span></div>
                        </td>
                        <td>
                        </td>
                    </tr>
                    <tr valign="top" style="height:85px">
                        <td>
                        </td>
                        <td style="border: 1px solid #000000; text-indent: 0px; ">
                            <div style="position: relative;  width:31px;height:68px;">
                                <span class="rotated" data-rotation="left" style="position: absolute; display: table; width:68px;height:31px;text-align: center;-webkit-transform: translate(-9px,18px) rotate(-90deg); -moz-transform: translate(-9px,18px) rotate(-90deg); -ms-transform: translate(-9px,18px) rotate(-90deg); -o-transform: translate(-9px,18px) rotate(-90deg); filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3); "><span style="display: table-cell; vertical-align:middle;"><span class="span">( 2 )</span></span></span></div>
                        </td>
                        <td style="border: 1px solid #000000; text-indent: 0px; ">
                            <div style="position: relative;  width:31px;height:68px;">
                                <span class="rotated" data-rotation="left" style="position: absolute; display: table; width:68px;height:31px;text-align: center;-webkit-transform: translate(-9px,18px) rotate(-90deg); -moz-transform: translate(-9px,18px) rotate(-90deg); -ms-transform: translate(-9px,18px) rotate(-90deg); -o-transform: translate(-9px,18px) rotate(-90deg); filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3); "><span style="display: table-cell; vertical-align:middle;"><span class="span">( 1 )</span></span></span></div>
                        </td>
                        <td style="border: 1px solid #000000; text-indent: 0px; ">
                            <div style="position: relative;  width:31px;height:68px;">
                                <span class="rotated" data-rotation="left" style="position: absolute; display: table; width:68px;height:31px;text-align: center;-webkit-transform: translate(-9px,18px) rotate(-90deg); -moz-transform: translate(-9px,18px) rotate(-90deg); -ms-transform: translate(-9px,18px) rotate(-90deg); -o-transform: translate(-9px,18px) rotate(-90deg); filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3); "><span style="display: table-cell; vertical-align:middle;"><span class="span">المجموع</span></span></span></div>
                        </td>
                        <td style="border: 1px solid #000000; text-indent: 0px; ">
                            <div style="position: relative;  width:31px;height:68px;">
                                <span class="rotated" data-rotation="left" style="position: absolute; display: table; width:68px;height:31px;text-align: center;-webkit-transform: translate(-9px,18px) rotate(-90deg); -moz-transform: translate(-9px,18px) rotate(-90deg); -ms-transform: translate(-9px,18px) rotate(-90deg); -o-transform: translate(-9px,18px) rotate(-90deg); filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3); "><span style="display: table-cell; vertical-align:middle;"><span class="span">الهندسة</span></span></span></div>
                        </td>
                        <td style="border: 1px solid #000000; text-indent: 0px; ">
                            <div style="position: relative;  width:31px;height:68px;">
                                <span class="rotated" data-rotation="left" style="position: absolute; display: table; width:68px;height:31px;text-align: center;-webkit-transform: translate(-9px,18px) rotate(-90deg); -moz-transform: translate(-9px,18px) rotate(-90deg); -ms-transform: translate(-9px,18px) rotate(-90deg); -o-transform: translate(-9px,18px) rotate(-90deg); filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3); "><span style="display: table-cell; vertical-align:middle;"><span class="span">الجبر</span></span></span></div>
                        </td>
                        <td>
                        </td>
                    </tr>
                    <tr valign="top" style="height:35px">
                        <td>
                        </td>
                        <td style="background-color: #A8A8A8; border-top: 1px solid #000000; border-left: 2.5px solid #000000; border-bottom: 1px solid #000000; border-right: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{40 | toArabic}}</span></td>
                        <td style="background-color: #A8A8A8; border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{50 | toArabic}}</span></td>
                        <td colspan="2" style="background-color: #A8A8A8; border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{40 | toArabic}}</span></td>
                        <td style="background-color: #A8A8A8; border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{20 | toArabic}}</span></td>
                        <td style="background-color: #A8A8A8; border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{20 | toArabic}}</span></td>
                        <td colspan="2" style="background-color: #A8A8A8; border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{40 | toArabic}}</span></td>
                        <td style="background-color: #A8A8A8; border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{20 | toArabic}}</span></td>
                        <td style="background-color: #A8A8A8; border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{20 | toArabic}}</span></td>
                        <td style="background-color: #A8A8A8; border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{280 | toArabic}}</span></td>
                        <td style="background-color: #A8A8A8; border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{40 | toArabic}}</span></td>
                        <td style="background-color: #A8A8A8; border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{60 | toArabic}}</span></td>
                        <td style="background-color: #A8A8A8; border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{30 | toArabic}}</span></td>
                        <td style="background-color: #A8A8A8; border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{30 | toArabic}}</span></td>
                        <td style="background-color: #A8A8A8; border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{40 | toArabic}}</span></td>
                        <td style="background-color: #A8A8A8; border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{60 | toArabic}}</span></td>
                        <td style="background-color: #A8A8A8; border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{80 | toArabic}}</span></td>
                        <td dir="rtl" style="border-top: 1px solid #000000; border-left: 1px solid #000000; border-bottom: 1px solid #000000; border-right: 2.5px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class=" s">النهاية العظمى</span></td>
                        <td>
                        </td>
                    </tr>
                    <tr valign="top" style="height:35px">
                        <td>
                        </td>
                        <td style="background-color: #A8A8A8; border-top: 1px solid #000000; border-left: 2.5px solid #000000; border-bottom: 1px solid #000000; border-right: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{16 | toArabic}}</span></td>
                        <td style="background-color: #A8A8A8; border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{25 | toArabic}}</span></td>
                        <td colspan="2" style="background-color: #A8A8A8; border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{20 | toArabic}}</span></td>
                        <td style="background-color: #A8A8A8; border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{10 | toArabic}}</span></td>
                        <td style="background-color: #A8A8A8; border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{10 | toArabic}}</span></td>
                        <td colspan="2" style="background-color: #A8A8A8; border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{20 | toArabic}}</span></td>
                        <td style="background-color: #A8A8A8; border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{10 | toArabic}}</span></td>
                        <td style="background-color: #A8A8A8; border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{10 | toArabic}}</span></td>
                        <td style="background-color: #A8A8A8; border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{140 | toArabic}}</span></td>
                        <td style="background-color: #A8A8A8; border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{20 | toArabic}}</span></td>
                        <td style="background-color: #A8A8A8; border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{30 | toArabic}}</span></td>
                        <td style="background-color: #A8A8A8; border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">-</span></td>
                        <td style="background-color: #A8A8A8; border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">-</span></td>
                        <td style="background-color: #A8A8A8; border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{20 | toArabic}}</span></td>
                        <td style="background-color: #A8A8A8; border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{30 | toArabic}}</span></td>
                        <td style="background-color: #A8A8A8; border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{40 | toArabic}}</span></td>
                        <td dir="rtl" style="border-top: 1px solid #000000; border-left: 1px solid #000000; border-bottom: 1px solid #000000; border-right: 2.5px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class=" s">النهاية الصغرى</span></td>
                        <td>
                        </td>
                    </tr>
                    <tr valign="top" style="height:40px">
                        <td>
                        </td>
                        <td style="border-top: 1px solid #000000; border-left: 2.5px solid #000000; border-bottom: 1px solid #000000; border-right: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{student.level_fr ? student.level_fr: '-' | toArabic }}</span></td>
                        <td style="border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{student.level_en ? student.level_en: '-' | toArabic }}</span></td>
                        <td colspan="2" style="border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{student.tr_r |toArabic}}</span></td>
                        <td style="border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{student.com |toArabic}}</span></td>
                        <td style="border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{student.tr_f |toArabic}}</span></td>
                        <td colspan="2" style="border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{student.tr_d |toArabic}}</span></td>
                        <td style="border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{student.n2 |toArabic}}</span></td>
                        <td style="border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{student.n1 |toArabic}}</span></td>
                        <td style="border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{student.total |toArabic}}</span></td>
                        <td style="border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{student.sci |toArabic}}</span></td>
                        <td style="border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{student.total_math |toArabic}}</span></td>
                        <td style="border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{student.math_h |toArabic}}</span></td>
                        <td style="border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{student.math_g |toArabic}}</span></td>
                        <td style="border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{student.stu |toArabic}}</span></td>
                        <td style="border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{student.en |toArabic}}</span></td>
                        <td style="border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{student.ar |toArabic}}</span></td>
                        <td dir="rtl" style="border-top: 1px solid #000000; border-left: 1px solid #000000; border-bottom: 1px solid #000000; border-right: 2.5px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class=" s">درجات الطالب</span></td>
                        <td>
                        </td>
                    </tr>
                    <tr valign="top" style="height:45px">
                        <td>
                        </td>
                        <td colspan="11" style="border-top: 1px solid #000000; border-left: 2.5px solid #000000; border-bottom: 1px solid #000000; border-right: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class=" s">{{student.total|toWord}} درجة</span></td>
                        <td colspan="3" dir="rtl" style="border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class=" s">الدرجة بالحروف</span></td>
                        <td colspan="4" style="border: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b">{{student.total | toArabic}}</span></td>
                        <td dir="rtl" style="border-top: 1px solid #000000; border-left: 1px solid #000000; border-bottom: 1px solid #000000; border-right: 2.5px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class=" s">المجموع الكلى للطالب</span></td>
                        <td>
                        </td>
                    </tr>
                    <tr valign="top" style="height:45px">
                        <td>
                        </td>
                        <td colspan="11" style="border-top: 1px solid #000000; border-left: 2.5px solid #000000; border-bottom: 2.5px solid #000000; border-right: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">

                            <!-- <span class=" s">Static Text</span> -->
                            <span class=" s" v-if="student.total >= 238"> ممتاز</span>
                            <span class=" s" v-if="student.total < 238 && student.total >= 210"> جيد جدا</span>
                            <span class=" s" v-if="student.total < 210 && student.total >= 182"> جيد </span>
                            <span class=" s" v-if="student.total < 182 && student.total >= 140"> مقبول </span>
                        </td>
                        <td colspan="3" dir="rtl" style="border-top: 1px solid #000000; border-left: 1px solid #000000; border-bottom: 2.5px solid #000000; border-right: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class=" s">التقدير</span></td>
                        <td colspan="4" style="border-top: 1px solid #000000; border-left: 1px solid #000000; border-bottom: 2.5px solid #000000; border-right: 1px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class="s_b"> % {{(student.total*100/280).toFixed(2) | toArabic}} </span></td>
                        <td dir="rtl" style="border-top: 1px solid #000000; border-left: 1px solid #000000; border-bottom: 2.5px solid #000000; border-right: 2.5px solid #000000; text-indent: 0px;  vertical-align: middle;text-align: center;">
                            <span class=" s">النسبة المئوية</span></td>
                        <td>
                        </td>
                    </tr>

            <tr>
                <td colspan="20">

                    <div class="row text-right">
                       
                            <div class="col-6"><span class="fh-18">مدير المدرسة </span> <br /> ( &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;) </div>
                            <div class="col-6"> <span class="fh-18">ش . ط المدرسة</span> <br /> ( &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;) </div>
                           
                            
                        

                    </div>
                </td>

            </tr>
            <tr>
                <td colspan="16" >

                    <div class="row " style="margin-top:55px">

                        <div class="col-6 text-center">
                            <span class="fh-20">رئيس
                                لجنة النظام والمراقبة <br /><br />عادل يحيي محمد &nbsp; </span>
                        </div>
                        <div class="col-6 ">
                            <span class="fh-20 text-center">ختم مدير المدرسة<br /><div style="padding: 7px;border: 1px solid;border-radius: 50%;width: 119px;height: 48px;">ختم</div> </span>
                        </div>

                    </div>
                </td>

            </tr>
                </table>

            </td>

        </tr>
    </table>
</div>
</template>

<script>
import api from '@/api/axios';
// import { toArabic } from 'arabic-digits';
// var writtenNumber = require('written-number');
export default {
    data() {
        return {
            student: [],
            form: {
                check:'school_id'
            }
        }
    },
    mounted() {
        // this.GethataStudentBySchools();

        Vue.filter('toArabic', function (value) {
            return toArabic(value).replace(".", ",");
        })
        Vue.filter('toWord', function (value) {

            return writtenNumber(value, { lang: 'ar' });
        })
    },
    methods: {
        GethataStudentBySchools(id) {
            api.get('/searchstudentCertfications/'+ id).then(res => {
                this.student = res.data['student']
            })
        },
            printPage() {
      this.$htmlToPaper("printMe");
    }
    },
}
</script>

<style lang="scss" scoped>
.span {
    font-family: 'sultan', Arial, Helvetica, sans-serif;
    color: #000000;
    font-size: 17px;
    line-height: 1.1640625;
}

.s {
    font-family: 'jordan', Arial, Helvetica, sans-serif;
    color: #000000;
    font-size: 18px !important;
    line-height: 1.1640625;
}

.s_h {
    font-family: 'jordan', Arial, Helvetica, sans-serif;
    color: #000000;
    font-size: 20px !important;
    font-weight: 900;
    line-height: 1.1640625;
}

.s_b {
    font-family: 'sultan', Arial, Helvetica, sans-serif;
    color: #000000;
    font-size: 20px !important;
    line-height: 1.1640625;
}

.s_b_s {
    font-family: 'sultan', Arial, Helvetica, sans-serif;
    color: #000000;
    font-size: 25px !important;
    line-height: 1.1640625;
}

.s_bb {
    font-family: 'sultan', Arial, Helvetica, sans-serif;
    color: #000000;
    font-size: 13px !important;
    line-height: 1.1640625;
}

.img {
    width: 100px;
    height: 120px;
    padding-bottom: 3px;
    padding-top: 3px;
}



.certificate-container {
  padding: 20px;
  background-color: #fff;
  font-family: 'Cairo', sans-serif; /* يفضل استخدام خط عربي رسمي */
  position: relative;
}

/* النصوص العلوية */
.org-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 5px;
  color: #000;
}

/* مربع حالة النجاح */
.success-badge {
  background-color: #f3f3f3;
  border: 3px solid #000;
  padding: 10px 30px;
  font-size: 28px;
  font-weight: 900;
  margin-bottom: 15px;
  display: inline-block;
  min-width: 300px;
  border-radius: 4px;
}

.cert-title p {
  font-size: 20px;
  margin: 0;
  line-height: 1.4;
}
.cert-title .highlight {
  font-weight: bold;
  font-size: 24px;
  margin-top: 5px;
}

/* إطار الصورة */
.photo-frame {
  width: 150px; /* تم تقليل العرض قليلاً ليتناسب مع A4 */
  height: 200px;
  border: 1px solid #ccc;
  padding: 2px;
  background: #fff;
  margin-right: auto; /* للمحاذاة يسار */
}
.student-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* صناديق الأرقام (جلوس ومسلسل) */
.number-box {
  border: 3px solid #000;
  padding: 8px 20px;
  min-width: 220px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
}
.number-box .label {
  font-size: 20px;
  margin-left: 10px;
}
.number-box .value {
  font-size: 24px;
  font-weight: 900;
}

/* بيانات الطالب */
.cert-body {
  margin-top: 20px;
  padding-right: 20px;
}
.info-row {
  display: flex;
  align-items: baseline;
  margin-bottom: 12px;
  font-size: 22px;
}
.info-label {
  min-width: 140px; /* عرض ثابت للعنوان لضبط المحاذاة */
  font-weight: bold;
}
.info-value {
  border-bottom: 1px dashed #ccc; /* خط منقط تحت البيانات */
  flex-grow: 1;
  padding-right: 10px;
}

/* الفاصل */
.divider {
  border-top: 2px solid #000;
  margin: 20px 0;
}

/* تذييل المعلومات */
.cert-footer {
  font-size: 20px;
  font-weight: bold;
}
.footer-item {
  display: flex;
  align-items: center;
  gap: 10px;
}
.footer-item .f-label {
  color: #555;
}
.font-number {
  font-family: 'Arial', sans-serif; /* للأرقام الإنجليزية إن وجدت */
  letter-spacing: 1px;
}

/* تنسيقات الطباعة */
@media print {
  .success-badge {
    background-color: #f3f3f3 !important;
    -webkit-print-color-adjust: exact;
  }
  .number-box {
    border: 3px solid #000 !important;
  }
  .info-value {
    border-bottom: none !important; /* إخفاء الخط المنقط في الطباعة إذا أردت */
  }
}
</style>
